import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid"];
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import axios from "axios";
import { request } from "@/js/http/http_request.js";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import { stockReservationTypes } from "@/js/lists.ts";
import StockReservation from "@/components/stock/StockReservation.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultEntityAddForm = {
  quantity: 1,
  countryIds: [],
  reservationType: stockReservationTypes.DEFAULT.id,
  reservationUserId: null,
  reservationConsultantId: null,
  hasLowStockAlert: false,
  lowStockAlertQuantity: null,
  comment: "",
  valid: false
};
export default {
  name: "StockSplitFormModal",
  components: {
    StockReservation: StockReservation,
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    stock: Object | null,
    countries: Array
  },
  data: function data() {
    return {
      dialog: false,
      addingEntity: {
        form: _objectSpread({}, defaultEntityAddForm),
        subComponentsMountStatus: {
          stockReservation: false
        },
        isPending: false,
        cancellationToken: null
      },
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.addingEntity.isPending;
    },
    allCountriesSelected: function allCountriesSelected() {
      return this.addingEntity.form.countryIds.length === this.countries.length;
    },
    someCountriesSelected: function someCountriesSelected() {
      return this.addingEntity.form.countryIds.length > 0 && !this.allCountriesSelected;
    },
    getIconForIntendedCountriesCloser: function getIconForIntendedCountriesCloser() {
      if (this.allCountriesSelected) return "mdi-close-box";
      if (this.someCountriesSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    isValid: function isValid() {
      var _this$$refs$reservati;
      return this.addingEntity.form.valid && Object.values(this.addingEntity.subComponentsMountStatus).every(function (x) {
        return !!x;
      }) && ((_this$$refs$reservati = this.$refs.reservation) === null || _this$$refs$reservati === void 0 ? void 0 : _this$$refs$reservati.valid);
    }
  },
  created: function created() {},
  methods: {
    confirmSplitStock: function confirmSplitStock() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var ok, _this2$addingEntity$c, _this, _this2$addingEntity$f, valid, withoutValid;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$refs.confirm.open("Split stock", "Are you sure you want to split the stock ?", {
                color: "red"
              });
            case 2:
              ok = _context2.sent;
              if (!ok) {
                _context2.next = 16;
                break;
              }
              _this2.addingEntity.isPending = true;
              (_this2$addingEntity$c = _this2.addingEntity.cancellationToken) === null || _this2$addingEntity$c === void 0 || _this2$addingEntity$c.cancel();
              _this2.addingEntity.cancellationToken = axios.CancelToken.source();
              _this = _this2;
              _this2$addingEntity$f = _this2.addingEntity.form, valid = _this2$addingEntity$f.valid, withoutValid = _objectWithoutProperties(_this2$addingEntity$f, _excluded);
              _context2.next = 11;
              return request("/v1/stocks/".concat(_this2.stock.id_stock, "/split"), "post", withoutValid, true, "api", null, _this.addingEntity.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.addingEntity.isPending = false;
                          _this.addingEntity.cancellationToken = null;
                          errorData = getErrorData(e, _this.managedExceptions, "Unable to create the split", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 11:
              _this2.addingEntity.isPending = false;
              _this2.addingEntity.cancellationToken = null;
              _this2.$toasted.show("Split done", {
                type: "success"
              });
              _this2.$emit("entityCreated");
              _this2.close();
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    changeIntendedCountries: function changeIntendedCountries() {
      var _this3 = this;
      this.$nextTick(function () {
        if (_this3.allCountriesSelected) {
          _this3.addingEntity.form.countryIds = [];
        } else {
          _this3.addingEntity.form.countryIds = _this3.countries.map(function (x) {
            return x.id_country;
          });
        }
      });
    },
    updateStockReservation: function updateStockReservation(form) {
      if (!this.addingEntity.form.hasLowStockAlert && (form.stockReservationUserId > 0 || form.stockReservationConsultantId > 0)) {
        this.addingEntity.form.hasLowStockAlert = true;
      }
      this.addingEntity.form.reservationType = form.stockReservationType;
      this.addingEntity.form.reservationUserId = form.stockReservationUserId;
      this.addingEntity.form.reservationConsultantId = form.stockReservationConsultantId;
    },
    firstMountStockReservation: function firstMountStockReservation() {
      this.addingEntity.subComponentsMountStatus.stockReservation = true;
    },
    open: function open() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$stock;
        var defaultQuantity;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.resetData();
              _this4.dialog = true;
              _this4.addingEntity.form = _objectSpread({}, defaultEntityAddForm);
              if ((_this4$stock = _this4.stock) !== null && _this4$stock !== void 0 && _this4$stock.wine) {
                defaultQuantity = _this4.stock.wine.casings.find(function (wc) {
                  return wc.isDefault;
                }).quantity;
                if (defaultQuantity < _this4.stock.quantity) _this4.addingEntity.form.quantity = _this4.stock.wine.casings.find(function (wc) {
                  return wc.isDefault;
                }).quantity;
              }
              _this4.addingEntity.form.countryIds = _toConsumableArray(_this4.stock.country_ids);
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                _this4.resolve = resolve;
                _this4.reject = reject;
              }));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        this.dialog = false;
        this.resetData();
        this.$emit("closed");
      }
    },
    resetData: function resetData() {
      this.addingEntity.form = _objectSpread({}, defaultEntityAddForm);
    },
    filterIntegerKey: filterIntegerKey,
    filterVAutocomplete: filterVAutocomplete
  }
};